import devConfig from "./config.dev.amplify.json";
import stagingConfig from "./config.staging.amplify.json";
import prodConfig from "./config.prod.amplify.json";

let config;

switch (process.env.REACT_APP_STAGE) {
  case "prod":
    config = prodConfig;
    break;
  case "staging":
    config = stagingConfig;
    break;
  case "dev":
  default:
    config = devConfig;
}

export default config;
